import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { deprecate } from 'react-is-deprecated';
const Box = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    backgroundColor = 'neutral-tertiary',
    border,
    // deprecated
    borderColor,
    borderRadius = 'default',
    children,
    className,
    padding = 'default',
    textColor = 'default',
    ...rest
  } = _ref;
  // deprecate `border`
  if (border && !borderColor) {
    borderColor = 'neutral-tertiary';
  }
  const classNames = clsx(className, 'box', {
    'box-compact': padding === 'compact',
    [`bg-${backgroundColor}`]: !!backgroundColor && backgroundColor !== 'transparent',
    [`border-${borderColor}`]: !!borderColor,
    [`box-radius-${borderRadius}`]: borderRadius !== 'default',
    [`text-${textColor}`]: textColor !== 'default'
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classNames,
    ref: ref
  }, rest), children);
});
export default Box;